module.exports = new __parcel__URL__("machines_sunday_skirmish_trophy.49f72bb9.png").toString();